import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { Search } from 'lucide-react';

export default function SearchInput({ value, onChange, placeholder = 'Search...', ...rest }) {
  return (
    <TextField
      type="text"
      variant="outlined"
      size="small"
      fullWidth
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search size={18} color="#94A3B8" />
          </InputAdornment>
        ),
      }}
      {...rest}
    />
  );
}
